import React from 'react';
import { Button, Space } from 'antd';
import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  LinkOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import { MaterialStatus } from '../../config/chatWorkspaceScope.js';

function resolveSourceExternalLink(source) {
  const record = Object.assign({}, source);
  const metadata = Object.assign({}, record.metadata);
  const meta = Object.assign({}, record.meta);
  return [
    record.url,
    record.link,
    record.external_url,
    record.source_url,
    record.web_url,
    record.uri,
    metadata.url,
    meta.url,
  ]
    .map((candidate) => String(candidate ?? '').trim())
    .find((value) => ['https://', 'http://'].some((protocol) => value.startsWith(protocol))) ?? '';
}

const isolateRowAction = (action) => (event) => {
  event.stopPropagation();
  action?.();
};

export default function SourceRowActions({
  handleDeleteCancel,
  handleDeleteClick,
  handleRetrySource,
  normalizedSourceId,
  pendingDeleteSourceId,
  source,
  sourceRemovingId,
  themeTokens,
}) {
  const externalLink = resolveSourceExternalLink(source);
  const pendingDelete = pendingDeleteSourceId === normalizedSourceId;
  const actionStyle = { color: themeTokens.textSecondary };

  return (
    <Space className="flare-source-list-actions" size={2}>
      {externalLink ? (
        <Button
          aria-label="打开外部资料"
          href={externalLink}
          icon={<LinkOutlined />}
          onClick={isolateRowAction()}
          rel="noopener noreferrer"
          size="small"
          style={actionStyle}
          target="_blank"
          title="打开外部资料"
          type="text"
        />
      ) : null}
      {source.status === MaterialStatus.FAILED ? (
        <Button
          aria-label="重试资料处理"
          icon={<ReloadOutlined />}
          onClick={isolateRowAction(() => handleRetrySource(normalizedSourceId))}
          size="small"
          style={actionStyle}
          title="重试资料处理"
          type="text"
        />
      ) : null}
      {pendingDelete ? (
        <Button
          aria-label="取消删除"
          icon={<CloseOutlined />}
          onClick={isolateRowAction(() => handleDeleteCancel(normalizedSourceId))}
          size="small"
          style={actionStyle}
          title="取消删除"
          type="text"
        />
      ) : null}
      <Button
        aria-label={pendingDelete ? '确认删除资料' : '删除资料'}
        danger={pendingDelete}
        icon={pendingDelete ? <CheckOutlined /> : <DeleteOutlined />}
        loading={sourceRemovingId === normalizedSourceId}
        onClick={isolateRowAction(() => handleDeleteClick(normalizedSourceId))}
        size="small"
        style={actionStyle}
        title={pendingDelete ? '确认删除资料' : '删除资料'}
        type="text"
      />
    </Space>
  );
}
